module.exports = __webpack_public_path__ + "static/media/21_B.1f3913fa.png";